<template>
  <div :class="modifierClass" class="container">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: true,
      validator: value => ['sm', 'md', 'lg'].includes(value)
    }
  },
  computed: {
    modifierClass() {
      return `container--${this.size}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  margin: 0 auto;
  padding: 0 1rem;
  width: 100%;

  &--sm {
    max-width: 25rem;
  }

  &--md {
    max-width: 35rem;
  }

  &--lg {
    max-width: 45rem;
  }
}
</style>
